<template>
    <zoom-on-hover :img-normal="photo" :scale="2" class="img-fluid"></zoom-on-hover>
</template>

<script>
export default {
    props: ["photo"]
};
</script>